<template>
  <svg
    :fill="fill"
    version="1.1"
    id="Layer_1"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    x="0px"
    y="0px"
    viewBox="0 0 193.1 84.1"
    style="enable-background:new 0 0 193.1 84.1;"
    xml:space="preserve"
    :class="[
      'mis-logo',
      animate ? 'to-animate' : '',
      animate && inAnimation ? 'is-animating' : '',
      animate && finishedAnimation ? 'animation-ended' : ''
    ]"
    @transitionend="animationEnded"
  >
    <path
      class="logo-path"
      id="MIS"
      d="M175.6,83.7h-61v-6.5h60.9c5.8-0.1,10.5-4.8,10.4-10.6c-0.1-4.8-3.4-9-8.1-10.1c-1.5-0.4-3-0.7-4.9-1
	c0,0-4.5-0.5-16.7-2c-10-1.1-15.1-1.6-27.8-3.3c-1.7-0.2-3.4-0.6-5-1c-2.4-0.6-4.5-1.7-6.4-3.2c-2-1.8-3-4.4-2.6-7
	c-0.2-5.7,4.2-10.5,9.9-10.8h22.7v6.5h-21.4c-2.4,0-4.3,1.9-4.3,4.3c0,0,0,0,0,0l0,0c-0.1,1.7,1,3.3,2.6,3.8c1.6,0.6,7.8,1.3,10,1.7
	c1.7,0.3,22.2,2.7,22.2,2.7s20.1,2.6,21.6,2.8c9.3,0.9,16.1,9.2,15.2,18.4c-0.8,8.6-8,15.2-16.6,15.3L175.6,83.7L175.6,83.7z
	 M175.6,83.7h-61v-6.5h60.9c5.8-0.1,10.5-4.8,10.4-10.6c-0.1-4.8-3.4-9-8.1-10.1c-1.5-0.4-3-0.7-4.9-1c0,0-4.5-0.5-16.7-2
	c-10-1.1-15.1-1.6-27.8-3.3c-1.7-0.2-3.4-0.6-5-1c-2.4-0.6-4.5-1.7-6.4-3.2c-2-1.8-3-4.4-2.6-7c-0.2-5.7,4.2-10.5,9.9-10.8h22.7v6.5
	h-21.4c-2.4,0-4.3,1.9-4.3,4.3c0,0,0,0,0,0l0,0c-0.1,1.7,1,3.3,2.6,3.8c1.6,0.6,7.8,1.3,10,1.7c1.7,0.3,22.2,2.7,22.2,2.7
	s20.1,2.6,21.6,2.8c9.3,0.9,16.1,9.2,15.2,18.4c-0.8,8.6-8,15.2-16.6,15.3L175.6,83.7L175.6,83.7z M104.1,0v21.3H98V0H104.1z
	 M98,28.3h6.2v55.8H98V28.3z M104.1,0v21.3H98V0H104.1z M98,28.3h6.2v55.8H98V28.3z M47.8,84.1h-6.2V38c0.1-1.3-0.4-2.7-1.4-3.5
	c-0.7-0.5-1.6-0.7-2.4-0.7c-1.2,0-2,0-3.9,3L7.5,84.1H0l6.3-11.6c2.4-3,19.9-35.7,19.9-35.7C29.5,31.3,32,28,36,28
	c1.2-0.1,2.3-0.1,3.5,0c1.7,0.2,3.2,0.8,4.5,1.9c1.1,0.9,2,1.9,2.6,3.2c0.8,1.4,1.2,3,1.2,4.6V71c4.7-7.6,18.9-34,18.9-34
	c3.2-5.6,5.7-8.9,9.7-8.9c1.2-0.1,2.3-0.1,3.5,0c1.6,0.2,3.1,0.8,4.3,1.8c1.1,0.9,2,1.9,2.6,3.2c0.8,1.4,1.2,3,1.2,4.6v46.4h-6.1V38
	c0.3-1.9-1-3.7-2.9-4c0,0,0,0,0,0h-0.2h-0.8c-1.2,0-2,0-3.9,3L47.8,84.1z"
    />


    
  </svg>
</template>

<script>
export default {
  props: {
    animate: {
      type: Boolean,
      default: false
    },
    fill: {
      type: String,
      default: "#0068AA"
    }
  },
  data() {
    return {
      inAnimation: false,
      finishedAnimation: false
    };
  },
  mounted() {
    if (this.animate) {
      setTimeout(
        function() {
          this.inAnimation = true;
        }.bind(this),
        500
      );
    }
  },
  methods: {
    animationEnded(e) {
      // console.log('animationEnded');
      this.finishedAnimation = true;
      this.$emit("animation-end", e);
    }
  }
};
</script>

<style lang="stylus" scoped>
.mis-logo
  &.with-slogan
    position relative
    left 50%
    width 10vmax
    max-width 130px
    transition transform 0.4s ease-out-expo, left 0.9s ease-out-expo
    transform translateX(-75%)
  +above(1100px)
    min-width 80px
  +below(1100px)
    height 44px
  +below(768px)
    height 40px
  &.to-animate
    .logo-path
      stroke blue_primary
      stroke-width 0.7px
      stroke-dasharray 1833
      stroke-dashoffset 1833
      backface-visibility hidden
      transform translateZ(0)
      fill rgba(blue_primary, 0)
      transition stroke-dashoffset 3s ease-out, stroke 1s 2s ease-out, fill 1s 2s ease-out
  &.is-animating
    .logo-path
      stroke-dashoffset 1300
      fill rgba(blue_primary, 1)
  &.animation-ended
    left 0
    transform translateX(0)
    .logo-path
      stroke-dashoffset 1300
      fill rgba(blue_primary, 1)
</style>
